var _path, _path2, _path3, _path4, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneOption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 113,
    viewBox: "0 0 114 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_164_22255)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M58.2101 11.666C33.4501 11.666 13.3701 31.736 13.3701 56.506C13.3701 81.276 33.4501 101.346 58.2101 101.346C82.9701 101.346 103.05 81.266 103.05 56.506C103.05 31.746 82.9801 11.666 58.2101 11.666Z",
    fill: "url(#paint0_radial_164_22255)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 11.3848C30.96 11.3848 10.25 32.0848 10.25 57.6348C10.25 83.1848 30.96 103.885 56.5 103.885C82.04 103.885 102.75 83.1748 102.75 57.6348C102.75 32.0948 82.04 11.3848 56.5 11.3848Z",
    fill: "url(#paint1_linear_164_22255)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 11.3848C30.96 11.3848 10.25 32.0848 10.25 57.6348C10.25 83.1848 30.96 103.885 56.5 103.885C82.04 103.885 102.75 83.1748 102.75 57.6348C102.75 32.0948 82.04 11.3848 56.5 11.3848Z",
    fill: "#516CD3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 11.3848C30.96 11.3848 10.25 32.0848 10.25 57.6348C10.25 83.1848 30.96 103.885 56.5 103.885C82.04 103.885 102.75 83.1748 102.75 57.6348C102.75 32.0948 82.04 11.3848 56.5 11.3848Z",
    fill: "url(#paint2_radial_164_22255)",
    fillOpacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 11.3848C30.96 11.3848 10.25 32.0848 10.25 57.6348C10.25 83.1848 30.96 103.885 56.5 103.885C82.04 103.885 102.75 83.1748 102.75 57.6348C102.75 32.0948 82.04 11.3848 56.5 11.3848Z",
    fill: "url(#paint3_radial_164_22255)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M56.4904 11.666C31.7204 11.666 11.6504 31.736 11.6504 56.506C11.6504 81.276 31.7304 101.346 56.4904 101.346C81.2504 101.346 101.34 81.266 101.34 56.506C101.34 31.746 81.2604 11.666 56.4904 11.666Z",
    fill: "url(#paint4_radial_164_22255)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_164_22255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8098 37.6V74.4H66.5241V37.6H45.8098ZM43.7384 33H68.5956C69.7396 33 70.667 34.0298 70.667 35.3V76.7C70.667 77.9703 69.7396 79 68.5956 79H43.7384C42.5944 79 41.667 77.9703 41.667 76.7V35.3C41.667 34.0298 42.5944 33 43.7384 33ZM56.167 67.5C57.311 67.5 58.2384 68.5297 58.2384 69.8C58.2384 71.0703 57.311 72.1 56.167 72.1C55.0229 72.1 54.0956 71.0703 54.0956 69.8C54.0956 68.5297 55.0229 67.5 56.167 67.5Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_164_22255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.5002 12.6055C80.7102 12.6055 100.4 32.2955 100.4 56.5055C100.4 80.7155 80.7102 100.406 56.5002 100.406C32.2902 100.406 12.6002 80.7056 12.6002 56.5055C12.6002 32.3055 32.2902 12.6055 56.5002 12.6055ZM56.5002 7.43555C29.4002 7.43555 7.43018 29.4055 7.43018 56.5055C7.43018 83.6055 29.4002 105.576 56.5002 105.576C83.6002 105.576 105.57 83.6055 105.57 56.5055C105.57 29.4055 83.6002 7.43555 56.5002 7.43555Z",
    fill: "url(#paint5_linear_164_22255)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_164_22255",
    x: 39.667,
    y: 33,
    width: 33,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_164_22255"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_164_22255",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_164_22255",
    x: 3.43018,
    y: 7.43555,
    width: 106.14,
    height: 106.141,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_164_22255"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_164_22255",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_164_22255",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.9405 59.2914) scale(50.3982)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D0D6DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#3B5565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_164_22255",
    x1: 26.86,
    y1: 22.1348,
    x2: 86.15,
    y2: 93.1348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#312A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#756A74"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_164_22255",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.6597 30.6556) rotate(51.0441) scale(77.6487 77.6487)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_164_22255",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(90.0788 92.3223) rotate(-93.6705) scale(79.1728 88.2414)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34499C",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#516CD3",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861815,
    stopColor: "#516CD3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_164_22255",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.4018 55.905) scale(43.9926 43.9926)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#ECF2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#BDD1DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#719CB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#0A5478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004D73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_164_22255",
    x1: 25.0502,
    y1: 18.8355,
    x2: 87.9502,
    y2: 94.1656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFCFC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_164_22255"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113,
    height: 113,
    fill: "white",
    transform: "translate(0.166992)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneOption);
export default __webpack_public_path__ + "static/media/PhoneOption.bf18e79de3190da686a240277b93e068.svg";
export { ForwardRef as ReactComponent };